import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const isResizeObserverLoopError = (message) =>
    typeof message === 'string' && (
        message.includes('ResizeObserver loop completed with undelivered notifications') ||
        message.includes('ResizeObserver loop limit exceeded')
    );

window.addEventListener('error', (event) => {
    if (isResizeObserverLoopError(event.message)) {
        event.stopImmediatePropagation();
    }
}, true);

/**
 * Sets up the root of the React application and renders the main component.
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
